<template>
    <div>
        <b-row class="tMarge">
            <b-col v-if="isLoggedIn" style="padding-left:0;padding-right:0;">
                <navigation ref="mainNavbar"></navigation>
                <div class="main">
                    <router-view ref="mainContent" class="mainStyle" :style="'height: ' + checkItemHeight+ 'px;border:0px solid green'"></router-view>
                </div>
            </b-col>
            <b-col v-else>
                <Login></Login>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import navigation from '../components/servex/s-navigation/s-navigation.vue'
import Login from './login/login.vue'
import {userService} from '@/services'

    export default{
        name: "Home",
        data() {
            return{
                maxHeight : 0,
                maxWidth : 0,
                menuSaveHeight : 0
            }
        },
        components: {
            Login,
            navigation,
        },
        computed: {
            ...mapGetters(['getDatabase','getworkLicence','getLanguage','getScreenSize', 'getCheckSize']),
            currentRouteName : () => this.$route.name,
            isLoggedIn : () => userService.isLoggedIn(),
            checkItemHeight(){
                return this.maxHeight
            },
            checkItemWidth(){
                return this.maxWidth
            },
            mainNavbarHeight() {
                return this.$refs.mainNavbar.$el.clientHeight //height including padding
            },
        },
        methods: {
            setScreenDimensions(inWidth, inHeight) {

                let contentHeight = inHeight - this.mainNavbarHeight - 10 //La hauteur du div du contenu (La hauteur visible moins la hauteur de la navigation)
                this.$store.commit('changeScreenSizeW', inWidth)
                this.$store.commit('changeScreenSizeH', inHeight)
                this.maxHeight = contentHeight
                this.maxWidth = inWidth 

                contentHeight = contentHeight > 0 ? contentHeight : inHeight
                //alert(contentHeight)
                //this.$store.commit('changeVisibleScreenSizeH', contentHeight)
                this.$store.commit('changeNavigationH', (this.mainNavbarHeight - 10) )


                this.menuSaveHeight = this.$refs?.mainContent?.$el.querySelector("#s-menuSave")?.clientHeight
                if(this.menuSaveHeight){
                    this.$store.commit('changeMenuSaveH', this.menuSaveHeight)
                }
            },
            setScreenSize() {
                this.setScreenDimensions(window.innerWidth, window.innerHeight)
            },
            
        },
        mounted() {
            this.setScreenSize()
        },
        updated() {
            this.setScreenSize()
        },
        created() {
            userService.getSession()

            //window.addEventListener("resize", this.onResize);

            
            //init object to store window properties
            let windowSize = {
                w: window.outerWidth,
                h: window.outerHeight,
                iw: window.innerWidth,
                ih: window.innerHeight
            };


            window.addEventListener("resize", (e) => {

                //if window resizes
                if (window.outerWidth !== windowSize.w || window.outerHeight !== windowSize.h) {
                    windowSize.w = window.outerWidth; // update object with current window properties
                    windowSize.h = window.outerHeight;
                    windowSize.iw = window.innerWidth;
                    windowSize.ih = window.innerHeight;
                    console.log("you're resizing"); //output
                }
                //if the window doesn't resize but the content inside does by + or - 5%
                else if (window.innerWidth + window.innerWidth * .05 < windowSize.iw ||
                        window.innerWidth - window.innerWidth * .05 > windowSize.iw) {
                        console.log("you're zooming")
                        windowSize.iw = window.innerWidth;
                        //location.reload();
                }

                console.log('------------- onResize --------------- ');
                console.log(e)

                this.setScreenDimensions(e.srcElement.innerWidth, e.srcElement.innerHeight)


                console.log('e.InnerHeight : '+e.srcElement.innerHeight + '   e.InnerWidth : '+e.srcElement.innerWidth)
                console.log('innerHeight : '+window.innerHeight + '   innerWidth : '+window.innerWidth)
                console.log('height : '+this.getScreenSize.height + '   width : '+this.getScreenSize.width)
                console.log('mainNavbarHeight : '+this.mainNavbarHeight )

                //location.reload();
            }, false);

            
            
        }
    }
</script>

<style lang="scss" scoped>
/* DEFAULT VALUE */
.tMarge{
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border:1px solid lightgray;
    border-radius: 3px;
    overflow: hidden;
    background-color: $cBackLeftDark;//$ServexMainBack;
}
/*FIN -  DEFAULT VALUE */

.main{
    position:relative;
    margin-top:50px; //Decaller le div vers le bas de la hauteur de la navigation
    overflow-y: auto;
    overflow-x: hidden;
    background-color: $cBackLeftDark;//$ServexMainBack;
    padding:0px 2px 0px 2px;

    border:0px dashed red;
}

.mainStyle{
    height: auto;
    padding:0px 1px 0px 1px;
    //overflow: auto;
    overflow: hidden;
}

</style>

